var Initiator = /** @class */ (function () {
    function Initiator() {
        this.events = {};
        this.settings = {};
        this.incremental_name = 0;
    }
    Initiator.prototype.registerSetting = function (k, setting) {
        var key = 's_' + k;
        if (this.settings[key]) {
            console.error('Setting key already exists: ' + k);
        }
        this.settings[key] = setting;
        return this;
    };
    Initiator.prototype.registerEvent = function (k, event) {
        var key = 'e_' + k;
        if (this.settings[key]) {
            console.error('Event key already exists: ' + key);
        }
        this.events[key] = event;
        return this;
    };
    Initiator.prototype.getNewIncementalName = function () {
        var oldName = this.incremental_name;
        this.incremental_name++;
        return oldName;
    };
    return Initiator;
}());
export default Initiator;
